module.exports = __webpack_public_path__ + "static/media/Metang_gaussian2.0c886db8.png";